import { Injectable } from '@angular/core';
import { BaseServiceWithFilter } from '.';
import { Route } from '@cl/shared/models/routes/route.model';
import { HttpClient } from '@angular/common/http';
import { RouteFilter } from '@cl/shared/models/routes/route-filter.model';
import { lastValueFrom } from 'rxjs';
import { CommandResult } from '@cl/shared/models';

@Injectable({
    providedIn: 'root',
})
export class RoutesService extends BaseServiceWithFilter<Route, RouteFilter> {
    constructor(protected httpClient: HttpClient) {
        super(httpClient, '/api/v1/routes/');
    }

    async changeRouteOrder(routeId: number, orderId: number): Promise<CommandResult<void>> {
        return lastValueFrom(this.httpClient.put<CommandResult<void>>(`${this.baseApiUrl}change-order`, { routeId, orderId }));
    }

    async changeRoutesOrder(routeIds: number[], orderId: number): Promise<CommandResult<void>> {
        return lastValueFrom(this.httpClient.put<CommandResult<void>>(`${this.baseApiUrl}change-order-bulk`, { routeIds, orderId }));
    }
}
